/// <summary>
/// Mapping for processing method types.
/// The key is the internal processing method identifier (string),
/// and the value is the user-friendly display label.
/// </summary>
export const ProcessingMethodLabels: Record<string, string> = {
    Manual: "Manual Entry",
    SavedCard: "Saved Card",
    Terminal: "Terminal",
    PayByLink: "Pay by Link",
};

/**
 * Returns the key corresponding to a given value in a mapping object.
 * @param value - The value to find the key for.
 * @returns The key as a string if found, otherwise undefined.
 */
export function getKeyByValue(value: string): string | undefined {
    if (value.toLowerCase() === 'entry') return 'Manual';
    return Object.keys(ProcessingMethodLabels).find(key => ProcessingMethodLabels[key] === value) ?? value;
}